import { render, staticRenderFns } from "./BoughtPerCountryTable.vue?vue&type=template&id=b5c447f2&"
import script from "./BoughtPerCountryTable.vue?vue&type=script&lang=js&"
export * from "./BoughtPerCountryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports